import type { CompanySettings } from "./Settings";

export interface ImportTableColumnSetting {
	visible: boolean;
	required: boolean;
}

export type ImportTableColumn = keyof CompanySettings["importTableColumns"];

// ==========================================================================================
// IMPORT_FIELDS: If you are adding a new column, please also add it to all other places with this comment.
// Maintain the same order in all places for consistency.
// ==========================================================================================
export const DefaultImportTableColumns: Record<ImportTableColumn, ImportTableColumnSetting> = {
	// Basic Information
	grower: { visible: true, required: true },
	farm: { visible: true, required: false },
	field: { visible: true, required: true },

	// Attachments
	boundaryGeoJSON: { visible: true, required: true },
	pointsGeoJSON: { visible: true, required: false },
	zonesGeoJSON: { visible: false, required: false },
	fieldNotes: { visible: false, required: false },

	// Order
	isReadyToSample: { visible: true, required: false },
	dateFieldReadyEstimated: { visible: false, required: false },
	fieldPriority: { visible: true, required: false },
	collectBoundary: { visible: true, required: false },
	submissionNotes: { visible: true, required: false },

	// Deal
	density: { visible: true, required: true },
	depth: { visible: true, required: true },
	labName: { visible: false, required: false },
	testPackage: { visible: true, required: false },
	frequencyOfMicros: { visible: true, required: false },
	deal: { visible: true, required: true },

	// Lab Info
	labInstructions: { visible: false, required: false },
	microsList: { visible: true, required: false },
	lastCrop: { visible: false, required: false },
	nextCrop: { visible: false, required: false },
	yieldGoal: { visible: false, required: false },

	// Contacts
	branch: { visible: false, required: false },
	salesperson: { visible: true, required: false },
	salespersonMobilePhone: { visible: true, required: false },
	growerPhoneNumber: { visible: true, required: false },
	submitterName: { visible: false, required: false },
	submitterEmail: { visible: false, required: false },

	// Sync Codes
	eventId: { visible: false, required: false },
	labSubmissionCode: { visible: true, required: false },
	fieldId: { visible: true, required: false },
	externalId: { visible: false, required: false },
	externalFarmId: { visible: false, required: false },
	externalLabId: { visible: false, required: false },

	// Misc
	isTestJob: { visible: false, required: false },
};
